const useClickOut = (wrapperRef, emit, eventName) => {
  const handleClickOut = (event) => {
    if (event.target && wrapperRef.value && !event.composedPath().includes(wrapperRef.value)) {
      emit(eventName);
    }
  };
  return {
    handleClickOut
  };
};

export default useClickOut;
